<script>
    //import Icon from 'fa-svelte';
    //import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';

    import Button from "./form/Button.svelte";
    import {Label, Icon} from '@smui/button';
    import Menu from '@smui/menu';
    import List, {Item, Separator, Text} from '@smui/list';

    import FaIcon from 'fa-svelte';
    import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // the openness state of the button oevrlay menu
    export let opened = false;

    export let id;

    // reference to the overlay menu item
    let menu;

    // watcher for menu state
    $: if (menu) {
        menu.setOpen(opened);
    }

    function newParticipaid() {
        dispatch('new', 'participaid');
    }

    function newValueaid() {
        dispatch('new', 'valueaid');
    }

    function newTeamaid() {
        dispatch('new', 'teamaid');
    }
</script>

    <!--<div use:GroupItem {id} class="new-project-button">
        <Button on:click={() => opened = !opened} variant="raised">
            <Label>
                <FaIcon icon={faPlus}>
                </FaIcon>
                New Project
            </Label>
            <Icon class="material-icons" style="margin: 0;">arrow_drop_down</Icon>
        </Button>
        <Menu bind:this={menu} anchorCorner="BOTTOM_CENTER">
            <List>
                <Item on:SMUI:action={() => newValueaid()} disabled>
                    <Text>ValueAid <small>(coming soon)</small></Text>
                </Item>
                <Item on:SMUI:action={() => newParticipaid()}>
                    <Text>ParticipAid</Text>
                </Item>
                <Item on:SMUI:action={() => newTeamaid()} disabled>
                    <Text>TeamAid <small>(coming soon)</small></Text>
                </Item>
            </List>
        </Menu>
    </div>-->

<Button class="new-project-button" on:click style="height: 60px;">
    <Label>
        <FaIcon icon={faPlus}/>
        New Partipie
    </Label>
<!--    <Icon class="material-icons" style="margin: 0;">arrow_drop_down</Icon>-->
</Button>

<style>
    .new-project-button {
        text-align: center;
    }
</style>